import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BalanceReportFilterForm, PackageExpirationDateForm } from '../../../shared/interfaces/shared-interfaces';
import { DataWithPagination } from '../../interface';
import { BalanceReportApi } from '../api/balance-report-api';
import { BalanceReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class BalanceReportRepository extends Repository {
  constructor(private balanceReportApi: BalanceReportApi) {
    super();
  }

  getBalanceReport(filter: BalanceReportFilterForm): Observable<DataWithPagination<BalanceReport[]>> {
    return this.balanceReportApi.getBalanceReport(filter);
  }

  changePackageExpirationDate(packageExpiration: PackageExpirationDateForm): Observable<string> {
    return this.balanceReportApi.changePackageExpirationDate(packageExpiration);
  }
  setPackageAsExpired(packageCancel: PackageExpirationDateForm): Observable<string> {
    return this.balanceReportApi.setPackageAsExpired(packageCancel)
  }
}
